module.exports = __webpack_public_path__ + "static/media/releases.7d609266.svg";